// Create the Sky Players Manager instance as singleton
export const createSkyPlayersManager = () => ({
  instance: null,
  init() {
    if (!this.instance) {
      this.instance = new window.SkyPlayersManager({
        async: true,
        visiblethreshold: 75,
      });
    }
    return this.instance;
  },
});
